export const utils = {
    
    created(){
        // console.log('Utils loaded!');
    },

    methods:{

        createRandomGuid( length, index ) {
            var str = "";
            for ( ; str.length < length; str += Math.random().toString( 36 ).substr( 2 ) );
            return str.substr( 0, length ) + index;
        },

        resolveVariantObject(variants, settings){

            var variantID = 'default';

            for(var v in variants){

                if(variants[v].hasOwnProperty('conditions')){

                    //Test variant conditions

                    try {
                        if(eval(variants[v].conditions)){
                            
                            variantID = v;
                            break;
                        }
                    } catch (error) {
                        //console.log(variants[v].conditions, error);
                    }

                }
               
            }

            return variants[variantID];

        },

        resolveVariantModels({variants = this.variants, settings = this.settings, includeModels = true} = {}){
            
            var schema = JSON.parse(JSON.stringify(
                {
                    models:[],
                    sides:{},
                    addons:[],
                    measure:{}
                }
            ));


            
            //Resolve variant from all available variants variants
            var variantObj = this.resolveVariantObject(variants, settings);

            schema.sku = variantObj.sku;
            schema.name = variantObj.name;

            //Populate models
            if(variantObj.hasOwnProperty('models')){
                schema.models.push(...JSON.parse(JSON.stringify(variantObj.models)));
            }

            //Populate sides
            if(variantObj.hasOwnProperty('sides')){
                schema.sides = JSON.parse(JSON.stringify(variantObj.sides));
            }

            //Populate measure
            if(variantObj.hasOwnProperty('measure')){
                schema.measure = JSON.parse(JSON.stringify(variantObj.measure));
            }

            //Populate addons
            if(settings && settings.hasOwnProperty('addons')){

                for (var addon in settings.addons) {
                    
                    var addonObj = this.all_addons[addon];

                    //Check if addon is active on product
                    if(settings.addons[addon]){
                        
                        var addonVariantObj = this.resolveVariantObject(addonObj.variants, settings);
                        
                        schema.addons.push({id:addon, ...addonVariantObj});

                        //Remove default models
                        if(addonVariantObj.hasOwnProperty('exclude')){

                            addonVariantObj.exclude.forEach(model => {
                                var index = schema.models.indexOf(model);
                                if(index > 0){                                                    
                                    schema.models.splice(index, 1);
                                }
                            });

                        }

                        //Populate addon models
                        if(addonVariantObj && typeof addonVariantObj !== 'undefined'){
                            schema.models.push(...JSON.parse(JSON.stringify(addonVariantObj.models)));
                        }

                        
                    }
                }

            }

                
            if(!includeModels){
                delete schema.models;
                delete schema.sides;
                delete schema.measure;
            }

            
            return JSON.parse(JSON.stringify(schema));
            
      
            this.$forceUpdate();
       
          }
    }
}